import { FormInstance } from "antd";
import { WiFi } from "Utility/Types/status_identity_get_set";

export const setFields = (wifi: WiFi, form: FormInstance<any>) => {
  form.setFieldsValue({
    // FIXME:24/01/05 修改 ap_enable 顯示不同步 bug
    Wifi1_ap_enable: wifi?.wifi_config?.ap_enable,
    Wifi1_txpower: wifi?.wifi_config?.txpower || 100,
    Wifi1_btw: wifi?.wifi_config?.btw || "20M",
    Wifi1_CountryCode: wifi?.wifi_config?.CountryCode,
    Wifi1_bt_lwps: wifi?.wifi_config?.bt_lwps || "SSID-1",
    Wifi1_enable: wifi?.wifi_config?.port?.[0]?.basic?.enable,
    Wifi1_ssid: wifi?.wifi_config?.port?.[0]?.basic?.ssid,
    Wifi1_hidden_ssid: wifi?.wifi_config?.port?.[0]?.basic?.hidden_ssid,
    Wifi1_channel_id: wifi?.wifi_config?.port?.[0]?.basic?.channel_id,
    Wifi1_ap_isolate: wifi?.wifi_config?.port?.[0]?.basic?.ap_isolate,
    Wifi1_vlan: wifi?.wifi_config?.port?.[0]?.basic?.vlan || 1,
    Wifi1_auth: wifi?.wifi_config?.port?.[0]?.security?.wpa?.auth || "None",
    Wifi1_rekey: wifi?.wifi_config?.port?.[0]?.security?.wpa?.rekey || 0,
    Wifi1_passphrase: wifi?.wifi_config?.port?.[0]?.security?.wpa?.passphrase,

    Wifi2_enable: wifi?.wifi_config?.port?.[1]?.basic?.enable,
    Wifi2_ssid: wifi?.wifi_config?.port?.[1]?.basic?.ssid,
    Wifi2_hidden_ssid: wifi?.wifi_config?.port?.[1]?.basic?.hidden_ssid,
    Wifi2_channel_id: wifi?.wifi_config?.port?.[1]?.basic?.channel_id,
    Wifi2_ap_isolate: wifi?.wifi_config?.port?.[1]?.basic?.ap_isolate,
    Wifi2_vlan: wifi?.wifi_config?.port?.[1]?.basic?.vlan || 1,
    Wifi2_auth: wifi?.wifi_config?.port?.[1]?.security?.wpa?.auth || "None",
    Wifi2_rekey: wifi?.wifi_config?.port?.[1]?.security?.wpa?.rekey || 0,
    Wifi2_passphrase: wifi?.wifi_config?.port?.[1]?.security?.wpa?.passphrase,
    //M350
    Wifi_ap_mode: wifi?.wifi_ap_mode?.ap_mode || "off",
    Wifi_5g_CountryCode: wifi?.wifi_config_5g?.CountryCode,
    Wifi_5g_ap_enable: wifi?.wifi_config_5g?.ap_enable,
    Wifi_5g_btw: wifi?.wifi_config_5g?.btw,
    Wifi_5g_txpower: wifi?.wifi_config_5g?.txpower,
    Wifi1_5g_enable: wifi?.wifi_config_5g?.port?.[0]?.basic?.enable,
    Wifi1_5g_ssid: wifi?.wifi_config_5g?.port?.[0]?.basic?.ssid,
    Wifi1_5g_hidden_ssid: wifi?.wifi_config_5g?.port?.[0]?.basic?.hidden_ssid,
    Wifi1_5g_channel_id: wifi?.wifi_config_5g?.port?.[0]?.basic?.channel_id,
    Wifi1_5g_ap_isolate: wifi?.wifi_config_5g?.port?.[0]?.basic?.ap_isolate,
    Wifi1_5g_vlan: wifi?.wifi_config_5g?.port?.[0]?.basic?.vlan,
    Wifi1_5g_auth: wifi?.wifi_config_5g?.port?.[0]?.security?.wpa?.auth,
    Wifi1_5g_rekey: wifi?.wifi_config_5g?.port?.[0]?.security?.wpa?.rekey,
    Wifi1_5g_passphrase: wifi?.wifi_config_5g?.port?.[0]?.security?.wpa?.passphrase,
    Wifi2_5g_enable: wifi?.wifi_config_5g?.port?.[1]?.basic?.enable,
    Wifi2_5g_ssid: wifi?.wifi_config_5g?.port?.[1]?.basic?.ssid,
    Wifi2_5g_hidden_ssid: wifi?.wifi_config_5g?.port?.[1]?.basic?.hidden_ssid,
    Wifi2_5g_channel_id: wifi?.wifi_config_5g?.port?.[1]?.basic?.channel_id,
    Wifi2_5g_ap_isolate: wifi?.wifi_config_5g?.port?.[1]?.basic?.ap_isolate,
    Wifi2_5g_vlan: wifi?.wifi_config_5g?.port?.[1]?.basic?.vlan,
    Wifi2_5g_auth: wifi?.wifi_config_5g?.port?.[1]?.security?.wpa?.auth,
    Wifi2_5g_rekey: wifi?.wifi_config_5g?.port?.[1]?.security?.wpa?.rekey,
    Wifi2_5g_passphrase: wifi?.wifi_config_5g?.port?.[1]?.security?.wpa?.passphrase,
  });
};

export const SSIDtags = ["SSID-1", "SSID-2"];
export const VLANOptions = [
  { value: 1, name: "NET1" },
  { value: 2, name: "NET2" },
  { value: 3, name: "NET3" },
  { value: 4, name: "NET4" },
  { value: 5, name: "NET5" },
  { value: 6, name: "NET6" },
  { value: 7, name: "NET7" },
  { value: 8, name: "NET8" },
];

export const ap_mode = ["off", "2.4g", "5g"];
export const authoptions = ["None", "WPA2-PSK-AES"];
// FOR M301-GW-A 待確認
export const authoptionsM301GWA = ["None", "WPA-PSK-AES", "WPA2-PSK-AES"];
